import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadIpmaCisDetailsCreator,
  approveIpmaChangeRequestCreator,
} from '../../../../../store/actionsCreators';
import ViewChangeRequest from '../../../../../shared/ChangeRequest/View/ViewChangeRequest';

const mapStateToProps = ({ loading, ipma, user }) => ({
  loading: isLoading(loading, 'LOAD_IPMA_CIS_DETAILS'),
  profile: ipma.cis.changeRequests.profile,
  userPermissions: user.userPermissions,
  type: 'ipma',
});

const mapDispatchToProps = (dispatch) => ({
  loadDetails: (id, history) => dispatch(loadIpmaCisDetailsCreator('changeRequests', id, history)),
  approveChangeRequest: (id, payload) =>
    dispatch(approveIpmaChangeRequestCreator(id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewChangeRequest);
